module.exports = __webpack_public_path__ + "static/media/film-canister.134dbb7f.svg";